import { GoogleLogin, GoogleLogout } from "react-google-login";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  button_container: {
    margin: "auto",
    width: "10%",
    marginTop: "5em"
  }
})
const LoginView = () => {
  const [loginmanager, setLoginmanager] = useState({
    //this state manage login action status
    debug: null,
    login: false,
    loginResponse: false,
    loginResponsestr: "",
  });

  const router_hystory = useHistory();
  const styles = useStyles()
  const clientId =
    "926693198610-ebli6ii5b420hflubloorbvkf53lqc51.apps.googleusercontent.com"; //gogole client id
  const fetchloginApi = (e) => {
    fetch("https://fcsn6t.deta.dev/account/login", {
      //fetch the api
      method: "GET",
      headers: {
        "X-Token": e.tokenId,
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (json) {
          if (json.error) {
            setLoginmanager({
              //this state manage login action status
              login: false,
              loginResponse: false,
              loginResponsestr: "",
            });
            let storToken = sessionStorage.getItem("xtoken");
            if (storToken) {
              sessionStorage.removeItem("xtoken");
            }
          } else {
            window.sessionStorage.setItem(
              "xtoken",
              JSON.stringify({ id_token: e.tokenId })
            );
            setLoginmanager({
              ...loginmanager,
              login: true,
              loginResponsestr: json.action,
              loginResponse: true,
            });
            router_hystory.push("/user");
          }
        } else {
          console.log("null");
        }
      });
  };

  useEffect(() => {
    let storToken = sessionStorage.getItem("xtoken");
    if (storToken) {
      let xtoken = { tokenId: JSON.parse(storToken).id_token };
      fetchloginApi(xtoken);
    }
  }, []);
  const responseGoogle = (e) => {
    //claback fucntion on login
    if (loginmanager.login === false) {
      fetchloginApi(e);
    }
  };
  const logout = () => {
    //calaback funxtion on logout
    console.log("User signed out.");
    setLoginmanager({
      login: false,
      loginResponse: false,
      loginResponsestr: "",
    });
    sessionStorage.removeItem("xtoken");
  };

  if (loginmanager.login) {
    //if is logged
    if (loginmanager.loginResponse) {
      //if response exist
      return (
        //return resposne status
        <div className={styles.button_container}>
          <p>{loginmanager.loginResponsestr}</p>
          <GoogleLogout
            clientId={clientId}
            buttonText="Logout"
            onLogoutSuccess={logout}
          ></GoogleLogout>
        </div>
      );
    } else {
      return (
        <div className={styles.button_container}>
          <GoogleLogout
            clientId={clientId}
            buttonText="Logout"
            onLogoutSuccess={logout}
          ></GoogleLogout>
        </div>
      );
    }
  } else {
    //return login page
    return (
      <div className={styles.button_container}>
        <GoogleLogin
          clientId={clientId}
          buttonText="Login"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={"single_host_origin"}
        />
      </div>
    );
  }
};

export default LoginView;
